<app-page-header title="Payment Transaction Log" subtitle="View and manage payment transaction history">
    <div actions class="flex gap-2 items-center">
        <p-datepicker [(ngModel)]="startDate" dateFormat="yy-mm-dd" placeholder="Start Date" styleClass="w-[160px]"></p-datepicker>
        <p-datepicker [(ngModel)]="endDate" dateFormat="yy-mm-dd" placeholder="End Date" styleClass="w-[160px]"></p-datepicker>
        <p-button label="Search" (click)="searchLogs()" icon="pi pi-search"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-confirmpopup />
    <div class="flex justify-end mb-3">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search in results" (input)="onGlobalSearch($event)" />
        </p-iconfield>
    </div>
    <p-table
        #dt
        [value]="logs"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="[
            'orderId',
            'pnr',
            'amount',
            'type',
            'providerPaymentStatus',
            'reservationStatus',
            'clientIp',
            'pspTransactionId'
        ]"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="orderId" class="text-left">
                    <div class="flex items-center gap-2">
                        Order ID
                        <p-sortIcon field="orderId"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="orderId" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pnr" class="text-left">
                    <div class="flex items-center gap-2">
                        PNR
                        <p-sortIcon field="pnr"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pnr" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="amount" class="text-left">
                    <div class="flex items-center gap-2">
                        Amount
                        <p-sortIcon field="amount"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="type" class="text-left">
                    <div class="flex items-center gap-2">
                        Type
                        <p-sortIcon field="type"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="type" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="providerPaymentStatus" class="text-left">
                    <div class="flex items-center gap-2">
                        Payment Status
                        <p-sortIcon field="providerPaymentStatus"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="providerPaymentStatus" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="reservationStatus" class="text-left">
                    <div class="flex items-center gap-2">
                        Reservation Status
                        <p-sortIcon field="reservationStatus"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="reservationStatus" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="requestDate" class="text-left">
                    <div class="flex items-center gap-2">
                        Request Date
                        <p-sortIcon field="requestDate"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="clientIp" class="text-left">
                    <div class="flex items-center gap-2">
                        Client IP
                        <p-sortIcon field="clientIp"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="pspTransactionId" class="text-left">
                    <div class="flex items-center gap-2">
                        PSP Transaction ID
                        <p-sortIcon field="pspTransactionId"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[100px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.orderId }}</td>
                <td>{{ row.pnr }}</td>
                <td>{{ row.amount }}</td>
                <td>{{ row.type }}</td>
                <td>
                    <span
                        [ngClass]="row.providerPaymentStatus === 'SUCCEED' ? 'status-badge status-active' : 'status-badge status-inactive'"
                    >
                        {{ row.providerPaymentStatus }}
                    </span>
                </td>
                <td>
                    <span
                        [ngClass]="{
                            'status-badge status-active': row.reservationStatus === 'TICKETED',
                            'status-badge status-inactive': row.reservationStatus === 'CANCELLED',
                            'status-badge': row.reservationStatus !== 'TICKETED' && row.reservationStatus !== 'CANCELLED'
                        }"
                    >
                        {{ row.reservationStatus }}
                    </span>
                </td>
                <td>{{ row.requestDate | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
                <td>{{ row.clientIp }}</td>
                <td>{{ row.pspTransactionId }}</td>
                <td class="text-right">
                    @if (row.reservationEligibleForComplete) {
                        <p-button
                            [text]="true"
                            severity="success"
                            icon="pi pi-check-circle"
                            (click)="confirmComplete($event, row)"
                            pTooltip="Complete Reservation"
                        ></p-button>
                    }
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
